module.exports = __webpack_public_path__ + "img/pie-chart.e7fc44e3.svg";